<template>
  <div class="robbing">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" :class="{'select':statusType=='ing'}" @click="toggleType('ing')">进行中</div>
      <div class="robbing-nav-item" :class="{'select':statusType=='complete'}" @click="gotoOtherStatus('complete')">已完成
      </div>
      <div class="robbing-nav-item" :class="{'select':statusType=='cancel'}" @click="gotoOtherStatus('cancel')">已取消
      </div>
      <div class="robbing-nav-item" v-if="type==2" @click="gotoPaotuiOrderDownload">今日数据</div>
    </nav>
    <div class="empty-data" v-if="!haveData">
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p>暂无数据</p>
      </div>
    </div>

    <section class="robbing-order" v-for="item in paotuiOrders" :key="item._id">
      <figure class="robbing-order-item">
        <div class="order-item-top">
          <div class="item-top-left">
            <span>{{item.typeStr}}</span>
          </div>
          <div class="item-top-right">
            <span style="color: red;">状态：{{item.statusStr}}</span>
            <span class="zhuandan-single" v-if="type==2 && item.status==1 && !isBatchOrdering"
              @click="singleOrder(item._id)">转单</span>
            <span class="zhuandan-batch" v-if="type==2 && item.status==1 && !isBatchOrdering"
              @click="batchOrder">批转</span>
            <input type="checkbox" v-model="item.check" style="vertical-align: middle; zoom: 1.5;"
              v-if="type==2 && item.status==1 && isBatchOrdering" @change="check(item)" />
            <span v-if="item.status==0">, 还有{{item.timeLeft}}</span>
            <span v-if="type==1 && (item.status==-1 || item.status==0) && userInfo.openid==item.openid"
              class="go-cancel" @click="cancel(item)">取 消</span>
          </div>
        </div>
        <div class="weui-cells weui-cells_form" style="margin-top: 0px;">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>跑腿单号</p>
            </div>
            <div class="weui-cell__ft">{{item.orderNo}}</div>
          </div>
          <div class="weui-cell" v-if="item.type == 1">
            <div class="weui-cell__bd">
              <p>{{item.expressCompanyName}}</p>
            </div>
            <div class="weui-cell__ft">{{item.expressNo}}</div>
          </div>
          <div class="weui-cell" v-if="item.type == 1 && !item.isBoxStorage">
            <div class="weui-cell__bd">
              <p>货架： {{item.storageNo}}-{{item.tag}}</p>
            </div>
            <div class="weui-cell__ft">
              <i class="iconfont icon-mobilephone"></i>
              {{item.initiatorPhone}}
            </div>
          </div>
          <div class="weui-cell" v-else-if="item.type==1 && item.isBoxStorage">
            <div class="weui-cell__bd">
              <p>
                {{item.storageNo&&item.storageNo!='默认'?item.storageNo+'号柜，':''}}
                <span style="color: red; font-weight: bold;">{{item.password}}</span>
              </p>
            </div>
            <div class="weui-cell__ft">
              <i class="iconfont icon-mobilephone"></i>
              {{item.initiatorPhone}}
            </div>
          </div>
          <div class="weui-cell" v-if="item.expressTakein">
            <div class="weui-cell__bd">
              <p>待寄物品</p>
            </div>
            <div class="weui-cell__ft">{{item.expressTakein.goodsName}}
              x{{item.expressTakein.goodsCount?item.expressTakein.goodsCount:1}}</div>
          </div>
          <div class="weui-cell" v-if="item.expressTakein && item.expressTakein.insureMoney">
            <div class="weui-cell__bd">
              <p>
                保价金额
                <span style="font-size: 12px; color: gold;">（保价费：{{item.expressTakein.insureFreight}} 元）</span>
              </p>
            </div>
            <div class="weui-cell__ft">{{item.expressTakein.insureMoney}} 元</div>
          </div>
        </div>
        <div class="robbing-order-add">
          <div class="order-add-start" style="flex: 3;">
            <div>
              <i class="iconfont icon-map" aria-hidden="true" style="font-weight: bold"></i>
            </div>
            <div style="padding: 4px;">{{item.startPoint}}</div>
          </div>
          <div class="order-add-to" style="border-left: 1px solid #eee; border-right: 1px solid #eee; color: #1aad19;">
            <i class="iconfont icon-jiantou2" aria-hidden="true" style="font-size: 32px;"></i>
          </div>
          <div class="order-add-end" style="flex: 3;">
            <div>
              <i class="iconfont icon-map" aria-hidden="true" style="font-weight: bold"></i>
            </div>
            <div style="padding: 4px;">{{item.endPoint}}</div>
          </div>
        </div>

        <div class="robbing-order-msg">
          <div class="order-msg-item" style="flex: 1" v-if="type == 1">
            <i class="iconfont icon-kuaidiyuan-xianxing" style="font-size: 18px;"></i>
            {{item.acceptUser?item.acceptUser:'暂无'}}
            <a :href="'tel:'+item.acceptUserPhone" v-if="item.acceptUserPhone" style="color: blue;">
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </div>
          <div class="order-msg-item" style="flex: 1" v-if="type == 2">
            <i class="iconfont icon-account"></i>
            {{item.proxyReceiver?item.proxyReceiver:item.initiator}}
            <a :href="'tel:'+(item.proxyReceiverPhone||item.initiatorPhone)" style="color: blue;">
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </div>
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-daxiao" aria-hidden="true"></i>
            {{item.goodsType==1?"小件":""}}{{item.goodsType==2?"中件":""}}{{item.goodsType==3?"大件":""}}{{item.goodsName?item.goodsName:""}}
          </div>
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-rmb" aria-hidden="true"></i>
            {{item.payFee/100}}元
          </div>
        </div>

        <div class="robbing-order-msg" v-if="item.type==2 && item.haveFreight">
          <div class="order-msg-item" style="flex: 1">
            {{item.expressCompanyName}}
            <span v-if="!item.expressTakein.isDaofu">（￥{{item.freight / 100}} 元）</span>
            <span v-if="item.expressTakein.isDaofu">（到付）</span>
          </div>
        </div>

        <div class="robbing-order-remark">
          <div class="order-remark-left" align="center">描述</div>
          <div class="order-remark-center">
            <div class="order-item-time" style="font-size: 14px; margin-right: 60px; min-height: 60px;">
              <!-- <p style="font-weight: bold; color: red;">跑腿性别要求： {{item.sexLimitStr}}</p> -->
              <p>
                时间：
                <span style="color: orangered; font-weight: bold;">{{item.serviceTime}}</span>
              </p>
              <p>备注： {{item.remark?item.remark:'无'}}</p>
            </div>
          </div>
          <div class="order-remark-right" v-if="item.qrimgBase64">
            <img class="block-img" :src="item.qrimgBase64" alt @click="showImagePreview(item.qrimgBase64)" />
          </div>
        </div>

        <div class="weui-cells" style="margin-top: -1px;" v-if="type==2 && item.status!=2 && item.goodsPic">
          <a class="weui-cell weui-cell_access" href="javascript:;" @click="showImagePreview(item.goodsPic)">
            <div class="weui-cell__bd">
              <p>待寄物品照片</p>
            </div>
            <div class="weui-cell__hd">
              <img class="block-img" :src="item.goodsPic" alt />
            </div>
          </a>
        </div>

        <!-- 上门取件的时候，为了避免混淆，需要拍照记录 -->
        <div class="weui-cells weui-cells_form" :id="'uploader'+item._id" style="margin-top: -1px;"
          v-if="type== 2 && item.type==2 && item.status==2 && userInfo.openid==item.acceptOpenid">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <div class="weui-uploader">
                <div class="weui-uploader__hd">
                  <p class="weui-uploader__title">为了避免混淆请上传待寄件照片</p>
                  <div class="weui-uploader__info">
                    <span :id="'uploadCount'+item._id">0</span>/1
                  </div>
                </div>
                <div class="weui-uploader__bd">
                  <ul class="weui-uploader__files" :id="'uploaderFiles'+item._id"></ul>
                  <div class="weui-uploader__input-box">
                    <input :id="'uploaderInput'+item._id" class="weui-uploader__input" type="file" accept="image/*"
                      multiple />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="weui-cells weui-cells_form" style="margin-top: -1px;">
          <div class="weui-cell" v-if="item.rewardMoney > 0">
            <div class="weui-cell__bd">
              <p>额外赏金</p>
            </div>
            <div class="weui-cell__ft">{{item.rewardMoney / 100}} 元</div>
          </div>
        </div>
        <div class="robbing-order-msg" v-if="item.tags.length > 0">
          <div class="order-msg-item comment">
            <span :class="{'comment-good': (tag==1||tag==3), 'comment-bad':(tag==2||tag==4)}" v-for="tag in item.tags"
              :key="tag">
              <font v-if="tag==1">态度好</font>
              <font v-if="tag==2">态度差</font>
              <font v-if="tag==3">准时到达</font>
              <font v-if="tag==4">超时到达</font>
            </span>
          </div>
        </div>

        <section class="mail-tips" v-if="!item.freightPay && type== 2 && item.type==2 && item.status==2">
          <span style="font-size:14px; font-weight: bold;">运费信息</span>
          <p style="font-size:12px;">请填写待寄物品的重量，运费自动计算，支持手动修改。</p>
        </section>
        <div class="weui-cells weui-cells_form" style="margin-top: 0px;">
          <a class="weui-cell weui-cell_access" href="javascript:;"
            v-if="type== 2 && item.type==2 && !item.freightPay && item.status==2 && userInfo.openid==item.acceptOpenid"
            @click="chooseExpress(item)">
            <div class="weui-cell__bd">
              <p>快递公司</p>
            </div>
            <div class="weui-cell__ft">{{item.expressCompanyName?item.expressCompanyName:'请选择'}}</div>
          </a>
          <div class="weui-cell weui-cell_switch"
            v-if="type== 2 && item.type==2 && !item.freightPay && item.status==2 && userInfo.openid==item.acceptOpenid && item.showDaofu">
            <div class="weui-cell__bd">运费到付</div>
            <div class="weui-cell__ft">
              <label for="switchDaofu" class="weui-switch-cp">
                <input id="switchDaofu" class="weui-switch-cp__input" type="checkbox" v-model="item.isDaofu"
                  @click="daofu(item)" />
                <div class="weui-switch-cp__box"></div>
              </label>
            </div>
          </div>
          <div class="weui-cell weui-cell_vcode"
            v-if="type== 2 && item.type==2 && !item.isDaofu && item.status==2 && userInfo.openid==item.acceptOpenid">
            <div class="weui-cell__hd">
              <label class="weui-label">计费重量</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="number" v-model="item.freightWeight" placeholder="待寄物品重量"
                @focus="cacheFreight(item)" @blur="clearFreight(item)" style="text-align: right;" />
            </div>
            <div class="weui-cell__ft">
              <button class="weui-vcode-btn">kg</button>
            </div>
            <div class="weui-cell__ft" @click="getFreight(item)">
              <button class="weui-vcode-btn" style="color: #fff; background-color: #1aad19;">计 费</button>
            </div>
          </div>
          <div class="weui-cell weui-cell_vcode"
            v-if="type== 2 && item.type==2 && !item.isDaofu && item.status==2 && userInfo.openid==item.acceptOpenid">
            <div class="weui-cell__hd">
              <label class="weui-label">合计运费</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="number" v-model="item.freight" placeholder="请输入运费"
                style="text-align: right;" />
            </div>
            <div class="weui-cell__ft">
              <button class="weui-vcode-btn">
                <font style="padding-left: 1px;">元</font>
              </button>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="type==1 && item.status==-1 && userInfo.openid==item.openid" @click="goPay(item)">预付赏金</a>
        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="type== 2 && !isBatchOrdering && (item.status==1||item.status==2) && userInfo.openid==item.acceptOpenid"
          style="margin-bottom: 10px;" @click="cancelAccept(item)">取消接单</a>
        <a href="javascript:;" class="robbing-order-get success"
          v-if="type== 2 && item.type==1 && item.status==2 && userInfo.openid==item.acceptOpenid"
          @click="songda(item)">已送达</a>
        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="type== 1 && item.type==1 && (item.status==2||item.status==3) && userInfo.openid==item.openid"
          @click="qianshou(item)">确认签收</a>
        <a href="javascript:;" class="robbing-order-get success"
          v-if="type== 1 && item.type==2 && item.status==1 && userInfo.openid==item.openid"
          @click="qujian(item)">跑腿已取件</a>
        <!-- <a href="javascript:;" class="robbing-order-get success" v-if="type==2 && item.type==2 && !item.haveFreight && item.status==3 && userInfo.openid==item.acceptOpenid" @click="addFreight(item)">确认运费</a> -->
        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="type== 2 && item.type==2 && item.status==2 && userInfo.openid==item.acceptOpenid && item.expressTakein.isDaofu"
          @click="confirmQujian(item)">确认已取件</a>
        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="type==2 && item.type==2 && item.status==2 && userInfo.openid==item.acceptOpenid && !item.expressTakein.freightPay"
          @click="addFreight(item)">确认运费</a>
        <a href="javascript:;" class="robbing-order-get unclickable"
          v-if="type== 1 && item.type==2 && (item.status==2||item.status==3) && userInfo.openid==item.openid && !item.expressTakein.isDaofu">支付运费</a>
        <a href="javascript:;" class="robbing-order-get success"
          v-if="type== 1 && item.type==2 && item.status==10 && userInfo.openid==item.openid && !item.expressTakein.isDaofu"
          @click="payFreight(item)">支付运费</a>
        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="type== 1 && item.status==100 && item.toComment && userInfo.openid==item.openid"
          @click="comment(item)">评价领活跃度</a>
      </figure>
    </section>
    <div class="footer" v-if="isBatchOrdering">
      <div style="display: flex;">
        <div class="warehousing-footer-item cancel-batch" style="flex: 1" @click="cancelBatchOrder">取 消</div>
        <div class="warehousing-footer-item" style="flex:1" @click="chooseAcceptUser">转 单</div>
      </div>
    </div>
    <div class="weui-footer" v-if="!haveData">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>
<script>
import config from "../config/config.js";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import io from "socket.io-client";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      haveData: true,
      worksiteId: "",
      userInfo: {},
      type: "",
      statusType: "",
      escPicker: [
        {
          label: "请选择",
          value: ""
        }
      ],
      year: moment().format("YYYY"),
      imgs: [],
      paotuiOrders: [],
      tempFreightWeight: "",
      isBatchOrdering: false,
      choosedPaotuiOrders: [],
      paotuiPicker: null,
      paotuis: [],
      acceptUser: {},
      singleOrderId: null
    };
  },
  created() {
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });
    let that = this;
    this.type = this.$route.params.type;
    this.statusType = this.$route.params.status;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
        this.worksiteId = response.data.data.worksite._id;

        if (this.type == 2 && this.userInfo.paotuiStatus != 1) {
          // 我领取的，需要判断是否是跑腿，不是跑腿则跳转到跑腿申请页面
          loading.hide(function () { });
          this.$router.push("/paotuiApply/" + this.encodeToken);
          return;
        }

        // 获取本团队跑腿列表，方便转单
        axios
          .get("/api/user/getPaotuisByLeader/" + this.userInfo.paotuiLeader)
          .then(res => {
            if (res.data.success) {
              let list = res.data.data;
              for (let i = 0; i < list.length; i++) {
                if (this.userInfo._id == list[i]._id) {
                  continue; // 不能转给自己
                }
                this.paotuis.push({
                  text: list[i].realname + " - " + list[i].phoneMain,
                  value: list[i]._id,
                  openid: list[i].openid,
                  realname: list[i].realname,
                  phoneMain: list[i].phoneMain
                });
              }
            } else {
              weui.alert("获取团队成员列表失败");
            }
          })
          .catch(err => {
            weui.alert("获取团队成员列表失败");
          });

        const socket = io(config.socket, {
          transports: ["websocket"]
        });
        // 建立 socket 连接
        socket.on("connect", function () {
          console.log("socket.io connect...");
        });
        socket.on("reconnect_attempt", () => {
          socket.io.opts.transports = ["websocket", "polling"];
        });
        socket.on("paotuiOrderCancel", function (_id) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (_id == that.paotuiOrders[i]._id) {
              that.paotuiOrders.splice(i, 1);
            }
          }
          if (that.paotuiOrders.length == 0) {
            that.haveData = false;
          }
        });
        // 跑腿单已被抢，在这个列表页面，只有任务发出者才有必要处理
        socket.on("paotuiOrderRobbinged", function (item) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (item._id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 1;
              that.paotuiOrders[i].statusStr = "已接单";
              that.paotuiOrders[i].acceptUser = item.acceptUser;
              that.paotuiOrders[i].acceptUserPhone = item.acceptUserPhone;
            }
          }
        });
        // 跑腿单已领货
        socket.on("paotuiHaveGettedExpress", function (_id) {
          // 处于 ing 页面才处理
          if (that.statusType == "ing") {
            for (let i = 0; i < that.paotuiOrders.length; i++) {
              if (_id == that.paotuiOrders[i]._id) {
                that.paotuiOrders[i].status = 2;
                if (
                  that.paotuiOrders[i].type == 1 ||
                  that.paotuiOrders[i].type == 3 ||
                  that.paotuiOrders[i].type == 4
                ) {
                  that.paotuiOrders[i].statusStr = "已领货";
                } else if (that.paotuiOrders[i].type == 2) {
                  that.paotuiOrders[i].statusStr = "待跑腿确认";

                  if (that.type == 2) {
                    setTimeout(function () {
                      // 处理图片上传组件
                      let currItem = that.paotuiOrders[i];
                      /* 图片自动上传 */
                      let uploadCount = 0,
                        uploadList = [];
                      let uploadCountDom = document.getElementById(
                        "uploadCount" + currItem._id
                      );
                      weui.uploader("#uploader" + currItem._id, {
                        url: "/api/upload/uploadFile",
                        auto: true,
                        type: "file",
                        fileVal: "fileVal",
                        compress: {
                          width: 1600,
                          height: 1600,
                          quality: 0.8
                        },
                        onBeforeQueued: function (files) {
                          if (
                            [
                              "image/jpg",
                              "image/jpeg",
                              "image/png",
                              "image/gif"
                            ].indexOf(this.type) < 0
                          ) {
                            weui.alert("请上传正确格式的图片");
                            return false;
                          }
                          if (this.size > 4 * 1024 * 1024) {
                            weui.alert("请上传不超过4M的图片");
                            return false;
                          }
                          if (files.length > 1) {
                            // 防止一下子选中过多文件
                            weui.alert("最多只能上传1张图片");
                            return false;
                          }
                          if (uploadCount + 1 > 1) {
                            weui.alert("最多只能上传1张图片");
                            return false;
                          }

                          ++uploadCount;
                          uploadCountDom.innerHTML = uploadCount;
                        },
                        onQueued: function () {
                          uploadList.push(this);
                        },
                        onBeforeSend: function (data, headers) {
                          headers["Authorization"] = "Bearer " + that.token;
                          // return false; // 阻止文件上传
                        },
                        onProgress: function (procent) { },
                        onSuccess: function (ret) {
                          currItem.goodsPic = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
                        },
                        onError: function (err) {
                          console.log(err);
                        }
                      });

                      // 缩略图预览
                      document
                        .querySelector("#uploaderFiles" + currItem._id)
                        .addEventListener("click", function (e) {
                          let target = e.target;

                          while (
                            !target.classList.contains("weui-uploader__file") &&
                            target
                          ) {
                            target = target.parentNode;
                          }
                          if (!target) return;

                          let url = target.getAttribute("style") || "";
                          let id = target.getAttribute("data-id");

                          if (url) {
                            url = url
                              .match(/url\((.*?)\)/)[1]
                              .replace(/"/g, "");
                          }
                          let gallery = weui.gallery(url, {
                            className: "custom-name",
                            onDelete: function () {
                              weui.confirm("确定删除该图片？", function () {
                                --uploadCount;
                                uploadCountDom.innerHTML = uploadCount;
                                currItem.goodsPic = "";

                                for (
                                  var i = 0, len = uploadList.length;
                                  i < len;
                                  ++i
                                ) {
                                  var file = uploadList[i];
                                  if (file.id == id) {
                                    file.stop();
                                    break;
                                  }
                                }
                                target.remove();
                                gallery.hide();
                              });
                            }
                          });
                        });
                    }, 500);
                  }
                }
              }
            }
          }
        });
        socket.on("paotuiConfirmHaveGettedExpress", function (_id) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (_id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 3;
              that.paotuiOrders[i].statusStr = "待核算运费";
            }
          }
        });
        socket.on("expressPaotuiArrived", function (_id) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (_id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 5;
              that.paotuiOrders[i].statusStr = "待出库";
            }
          }
        });
        socket.on("paotuiSayReceiverGet", function (_id) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (_id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 3;
              that.paotuiOrders[i].statusStr = "已送达";
            }
          }
        });
        socket.on("freightUpdated", function (item) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (item._id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 10;
              that.paotuiOrders[i].statusStr = "待付运费";
              that.paotuiOrders[i].haveFreight = true;
              that.paotuiOrders[i].expressCompanyName = item.expressCompanyName;
              that.paotuiOrders[i].freight = item.freight;
              that.paotuiOrders[i].expressTakein.prepayId = item.prepayId;
            }
          }

          that.paotuiOrders = [...that.paotuiOrders];
        });
        socket.on("freightPaySuccess", function (_id) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (_id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 20;
              if (that.paotuiOrders[i].expressTakein.isDaofu) {
                that.paotuiOrders[i].statusStr = "到付待件到站";
              } else {
                that.paotuiOrders[i].statusStr = "已付待件到站";
              }
            }
          }
        });
        socket.on("freightPaySuccessDaofu", function (item) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (item._id == that.paotuiOrders[i]._id) {
              that.paotuiOrders[i].status = 20;
              that.paotuiOrders[i].expressTakein.isDaofu = true;
              that.paotuiOrders[i].statusStr = "到付待件到站";
              that.paotuiOrders[i].goodsPic = item.goodsPic;
            }
          }
        });
        socket.on("paotuiOrderComplete", function (_id) {
          for (let i = 0; i < that.paotuiOrders.length; i++) {
            if (_id == that.paotuiOrders[i]._id) {
              that.paotuiOrders.splice(i, 1);
            }
          }
          if (that.paotuiOrders.length == 0) {
            that.haveData = false;
          }
        });

        // 根据worksiteId 获取当前可用的寄件快递列表
        axios
          .get("/api/worksite/detail/" + this.worksiteId)
          .then(res => {
            let expressSendCompanies = res.data.data.expressSendCompanies;
            for (let i = 0; i < expressSendCompanies.length; i++) {
              let item = {
                label: expressSendCompanies[i].name,
                code: expressSendCompanies[i].code,
                value: expressSendCompanies[i]._id
              };
              this.escPicker.push(item);
            }
          })
          .catch(err => {
            weui.topTips("获取可用寄件快递列表失败", 2000);
          });

        // 获取跑腿列表
        axios
          .get(
            "/api/paotuiOrder/list/" +
            this.type +
            "/" +
            this.userInfo.openid +
            "/" +
            this.statusType
          )
          .then(res => {
            loading.hide(function () { });
            if (res.data.success) {
              this.paotuiOrders = res.data.data;
              if (this.paotuiOrders.length == 0) {
                this.haveData = false;
              }
              for (let i = 0; i < this.paotuiOrders.length; i++) {
                // 跑腿性别要求
                if (
                  !this.paotuiOrders[i].sexLimit ||
                  this.paotuiOrders[i].sexLimit == -1
                ) {
                  this.paotuiOrders[i].sexLimitStr = "不限";
                } else if (this.paotuiOrders[i].sexLimit == 1) {
                  this.paotuiOrders[i].sexLimitStr = "男";
                }
                if (this.paotuiOrders[i].sexLimit == 2) {
                  this.paotuiOrders[i].sexLimitStr = "女";
                }

                let du = moment.duration(
                  moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                  "ms"
                );
                this.paotuiOrders[i].timeLeft = du.locale("zh-cn").humanize();
                if (this.paotuiOrders[i].type == 1) {
                  this.paotuiOrders[i].typeStr = "送件上门 #" + this.paotuiOrders[i].seq;
                } else if (this.paotuiOrders[i].type == 2) {
                  this.paotuiOrders[i].typeStr = "上门取件";
                } else if (this.paotuiOrders[i].type == 3) {
                  this.paotuiOrders[i].typeStr = "餐饮服务";
                } else if (this.paotuiOrders[i].type == 4) {
                  this.paotuiOrders[i].typeStr = "其他服务";
                }

                if (this.paotuiOrders[i].qrimgBase64) {
                  this.paotuiOrders[i].qrimgBase64 =
                    "data:image/png;base64," + this.paotuiOrders[i].qrimgBase64;
                }

                let toDayStr = moment().format("YYYY-MM-DD");
                let nextDayStr = moment()
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let next2DayStr = moment()
                  .add(2, "days")
                  .format("YYYY-MM-DD");
                let doorServiceDayStr = moment(
                  this.paotuiOrders[i].requireArriveTime
                ).format("YYYY-MM-DD");
                if (doorServiceDayStr == toDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "今天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    ) +
                    "前";
                } else if (doorServiceDayStr == nextDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "明天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    ) +
                    "前";
                } else if (doorServiceDayStr == next2DayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "后天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    ) +
                    "前";
                } else {
                  let du = moment.duration(
                    moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                    "ms"
                  );
                  this.paotuiOrders[i].serviceTime =
                    du.locale("zh-cn").humanize() + "前";
                }

                // 状态
                if (this.paotuiOrders[i].status == -1) {
                  this.paotuiOrders[i].statusStr = "待支付";
                } else if (this.paotuiOrders[i].status == 0) {
                  this.paotuiOrders[i].statusStr = "待接单";
                } else if (this.paotuiOrders[i].status == 1) {
                  this.paotuiOrders[i].statusStr = "已接单";
                } else if (this.paotuiOrders[i].status == 2) {
                  if (
                    this.paotuiOrders[i].type == 1 ||
                    this.paotuiOrders[i].type == 3 ||
                    this.paotuiOrders[i].type == 4
                  ) {
                    this.paotuiOrders[i].statusStr = "已领货";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].statusStr = "待跑腿确认";
                  }
                } else if (this.paotuiOrders[i].status == 3) {
                  if (
                    this.paotuiOrders[i].type == 1 ||
                    this.paotuiOrders[i].type == 3 ||
                    this.paotuiOrders[i].type == 4
                  ) {
                    this.paotuiOrders[i].statusStr = "已送达";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].statusStr = "待核算运费";
                  }
                } else if (this.paotuiOrders[i].status == 4) {
                  this.paotuiOrders[i].statusStr = "已取消";
                } else if (this.paotuiOrders[i].status == 5) {
                  this.paotuiOrders[i].statusStr = "待出库";
                } else if (this.paotuiOrders[i].status == 10) {
                  this.paotuiOrders[i].statusStr = "待付运费";
                } else if (this.paotuiOrders[i].status == 20) {
                  if (that.paotuiOrders[i].expressTakein.isDaofu) {
                    that.paotuiOrders[i].statusStr = "到付待件到站";
                  } else {
                    that.paotuiOrders[i].statusStr = "已付待件到站";
                  }
                } else if (this.paotuiOrders[i].status == 100) {
                  this.paotuiOrders[i].statusStr = "已完成";
                }

                if (
                  this.paotuiOrders[i].expressTakein &&
                  this.paotuiOrders[i].expressTakein.insureMoney
                ) {
                  if (this.paotuiOrders[i].expressTakein.insureMoney) {
                    this.paotuiOrders[
                      i
                    ].expressTakein.insureFreight = Math.ceil(
                      (this.paotuiOrders[i].expressTakein.insureMoney *
                        config.insurePercent) /
                      100
                    );
                  } else {
                    this.paotuiOrders[i].expressTakein.insureFreight = 0;
                  }
                }

                // 如果type== 2 && !item.haveFreight && item.status==1 && userInfo.openid==item.acceptOpenid，去获取tosend 的信息， 用于填写运费
                if (this.paotuiOrders[i].type == 2) {
                  let currBizId = this.paotuiOrders[i].bizId;
                  axios
                    .get("/api/expressTakein/getById/" + currBizId)
                    .then(etRes => {
                      if (etRes.data.success) {
                        let currEt = etRes.data.data;
                        this.paotuiOrders[i].haveFreight =
                          currEt.freightPay || currEt.freight;
                        this.paotuiOrders[i].freight = currEt.freight;
                        this.paotuiOrders[i].freightPay = currEt.freightPay;
                        if (this.paotuiOrders[i].expressTakein) {
                          this.paotuiOrders[i].expressTakein.prepayId =
                            currEt.prepayId;
                        } else {
                          this.paotuiOrders[i].expressTakein = {
                            prepayId: currEt.prepayId
                          };
                        }
                        this.paotuiOrders[
                          i
                        ].expressCompanyId = currEt.expressCompany
                            ? currEt.expressCompany._id
                            : "";
                        this.paotuiOrders[
                          i
                        ].expressCompanyCode = currEt.expressCompany
                            ? currEt.expressCompany.code
                            : "";
                        this.paotuiOrders[
                          i
                        ].expressCompanyName = currEt.expressCompany
                            ? currEt.expressCompany.name
                            : "";
                        this.paotuiOrders[i].fromProvCode =
                          currEt.senderProvince.code;
                        this.paotuiOrders[i].toProvCode =
                          currEt.receiverProvince.code;

                        this.paotuiOrders = [...this.paotuiOrders];
                      } else {
                        weui.alert(etRes.data.message);
                      }
                    })
                    .catch(etErr => {
                      weui.alert("获取待取件信息出错");
                    });
                }

                if (
                  this.type == 2 &&
                  this.statusType == "ing" &&
                  this.paotuiOrders[i].type == 2 &&
                  this.paotuiOrders[i].status == 2 &&
                  this.userInfo.openid == this.paotuiOrders[i].acceptOpenid
                ) {
                  setTimeout(function () {
                    // 需要渲染文件上传组件
                    let currItem = that.paotuiOrders[i];
                    /* 图片自动上传 */
                    let uploadCount = 0,
                      uploadList = [];
                    let uploadCountDom = document.getElementById(
                      "uploadCount" + currItem._id
                    );
                    weui.uploader("#uploader" + currItem._id, {
                      url: "/api/upload/uploadFile",
                      auto: true,
                      type: "file",
                      fileVal: "fileVal",
                      compress: {
                        width: 1600,
                        height: 1600,
                        quality: 0.8
                      },
                      onBeforeQueued: function (files) {
                        if (
                          [
                            "image/jpg",
                            "image/jpeg",
                            "image/png",
                            "image/gif"
                          ].indexOf(this.type) < 0
                        ) {
                          weui.alert("请上传正确格式的图片");
                          return false;
                        }
                        if (this.size > 4 * 1024 * 1024) {
                          weui.alert("请上传不超过4M的图片");
                          return false;
                        }
                        if (files.length > 1) {
                          // 防止一下子选中过多文件
                          weui.alert("最多只能上传1张图片");
                          return false;
                        }
                        if (uploadCount + 1 > 1) {
                          weui.alert("最多只能上传1张图片");
                          return false;
                        }

                        ++uploadCount;
                        uploadCountDom.innerHTML = uploadCount;
                      },
                      onQueued: function () {
                        uploadList.push(this);
                      },
                      onBeforeSend: function (data, headers) {
                        headers["Authorization"] = "Bearer " + that.token;
                        // return false; // 阻止文件上传
                      },
                      onProgress: function (procent) { },
                      onSuccess: function (ret) {
                        console.log(ret.data);
                        currItem.goodsPic = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
                      },
                      onError: function (err) {
                        console.log(err);
                      }
                    });

                    // 缩略图预览
                    document
                      .querySelector("#uploaderFiles" + currItem._id)
                      .addEventListener("click", function (e) {
                        let target = e.target;

                        while (
                          !target.classList.contains("weui-uploader__file") &&
                          target
                        ) {
                          target = target.parentNode;
                        }
                        if (!target) return;

                        let url = target.getAttribute("style") || "";
                        let id = target.getAttribute("data-id");

                        if (url) {
                          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
                        }
                        let gallery = weui.gallery(url, {
                          className: "custom-name",
                          onDelete: function () {
                            weui.confirm("确定删除该图片？", function () {
                              --uploadCount;
                              uploadCountDom.innerHTML = uploadCount;
                              currItem.goodsPic = "";

                              for (
                                var i = 0, len = uploadList.length;
                                i < len;
                                ++i
                              ) {
                                var file = uploadList[i];
                                if (file.id == id) {
                                  file.stop();
                                  break;
                                }
                              }
                              target.remove();
                              gallery.hide();
                            });
                          }
                        });
                      });
                  }, 500);
                }
              }
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            this.haveData = false;
            loading.hide(function () { });
            weui.topTips("获取待接单数据出错", 2000);
          });
      })
      .catch(error => {
        this.haveData = false;
        loading.hide(function () { });
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    showImagePreview(img) {
      this.imgs = [img];
      this.$createImagePreview({
        imgs: this.imgs
      }).show();
    },
    toggleType(type) {
      let that = this;
      if (this.statusType != type) {
        this.statusType = type;
        let loading = weui.loading("数据加载中", {
          className: "custom-classname"
        });
        // 重新查询待接单数据
        axios
          .get(
            "/api/paotuiOrder/list/" +
            this.type +
            "/" +
            this.userInfo.openid +
            "/" +
            this.statusType
          )
          .then(res => {
            loading.hide(function () { });
            if (res.data.success) {
              this.paotuiOrders = res.data.data;
              if (this.paotuiOrders.length == 0) {
                this.haveData = false;
              } else {
                this.haveData = true;
              }
              for (let i = 0; i < this.paotuiOrders.length; i++) {
                // 跑腿性别要求
                if (
                  !this.paotuiOrders[i].sexLimit ||
                  this.paotuiOrders[i].sexLimit == -1
                ) {
                  this.paotuiOrders[i].sexLimitStr = "不限";
                } else if (this.paotuiOrders[i].sexLimit == 1) {
                  this.paotuiOrders[i].sexLimitStr = "男";
                }
                if (this.paotuiOrders[i].sexLimit == 2) {
                  this.paotuiOrders[i].sexLimitStr = "女";
                }

                let du = moment.duration(
                  moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                  "ms"
                );
                this.paotuiOrders[i].timeLeft = du.locale("zh-cn").humanize();
                if (this.paotuiOrders[i].type == 1) {
                  this.paotuiOrders[i].typeStr = "送件上门 #" + this.paotuiOrders[i].seq;
                } else if (this.paotuiOrders[i].type == 2) {
                  this.paotuiOrders[i].typeStr = "上门取件";
                } else if (this.paotuiOrders[i].type == 3) {
                  this.paotuiOrders[i].typeStr = "餐饮服务";
                } else if (this.paotuiOrders[i].type == 4) {
                  this.paotuiOrders[i].typeStr = "其他服务";
                }

                if (this.paotuiOrders[i].qrimgBase64) {
                  this.paotuiOrders[i].qrimgBase64 =
                    "data:image/png;base64," + this.paotuiOrders[i].qrimgBase64;
                }

                let toDayStr = moment().format("YYYY-MM-DD");
                let nextDayStr = moment()
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let next2DayStr = moment()
                  .add(2, "days")
                  .format("YYYY-MM-DD");
                let doorServiceDayStr = moment(
                  this.paotuiOrders[i].requireArriveTime
                ).format("YYYY-MM-DD");
                if (doorServiceDayStr == toDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "今天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    );
                } else if (doorServiceDayStr == nextDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "明天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    );
                } else if (doorServiceDayStr == next2DayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "后天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    );
                } else {
                  let du = moment.duration(
                    moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                    "ms"
                  );
                  this.paotuiOrders[i].serviceTime =
                    du.locale("zh-cn").humanize() + "前";
                }

                // 状态
                if (this.paotuiOrders[i].status == -1) {
                  this.paotuiOrders[i].statusStr = "待支付";
                } else if (this.paotuiOrders[i].status == 0) {
                  this.paotuiOrders[i].statusStr = "待接单";
                } else if (this.paotuiOrders[i].status == 1) {
                  this.paotuiOrders[i].statusStr = "已接单";
                } else if (this.paotuiOrders[i].status == 2) {
                  if (
                    this.paotuiOrders[i].type == 1 ||
                    this.paotuiOrders[i].type == 3 ||
                    this.paotuiOrders[i].type == 4
                  ) {
                    this.paotuiOrders[i].statusStr = "已领货";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].statusStr = "待跑腿确认";
                  }
                } else if (this.paotuiOrders[i].status == 3) {
                  if (
                    this.paotuiOrders[i].type == 1 ||
                    this.paotuiOrders[i].type == 3 ||
                    this.paotuiOrders[i].type == 4
                  ) {
                    this.paotuiOrders[i].statusStr = "已送达";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].statusStr = "待核算运费";
                  }
                } else if (this.paotuiOrders[i].status == 4) {
                  this.paotuiOrders[i].statusStr = "已取消";
                } else if (this.paotuiOrders[i].status == 5) {
                  this.paotuiOrders[i].statusStr = "待出库";
                } else if (this.paotuiOrders[i].status == 10) {
                  this.paotuiOrders[i].statusStr = "待付运费";
                } else if (this.paotuiOrders[i].status == 20) {
                  if (that.paotuiOrders[i].expressTakein.isDaofu) {
                    that.paotuiOrders[i].statusStr = "到付待件到站";
                  } else {
                    that.paotuiOrders[i].statusStr = "已付待件到站";
                  }
                } else if (this.paotuiOrders[i].status == 100) {
                  this.paotuiOrders[i].statusStr = "已完成";
                }

                if (
                  this.paotuiOrders[i].expressTakein &&
                  this.paotuiOrders[i].expressTakein.insureMoney
                ) {
                  if (this.paotuiOrders[i].expressTakein.insureMoney) {
                    this.paotuiOrders[
                      i
                    ].expressTakein.insureFreight = Math.ceil(
                      (this.paotuiOrders[i].expressTakein.insureMoney *
                        config.insurePercent) /
                      100
                    );
                  } else {
                    this.paotuiOrders[i].expressTakein.insureFreight = 0;
                  }
                }

                // 如果type== 2 && item.type==2 && !item.haveFreight && item.status==1 && userInfo.openid==item.acceptOpenid，去获取tosend 的信息， 用于填写运费
                if (this.paotuiOrders[i].type == 2) {
                  let currBizId = this.paotuiOrders[i].bizId;
                  axios
                    .get("/api/expressTakein/getById/" + currBizId)
                    .then(etRes => {
                      if (etRes.data.success) {
                        let currEt = etRes.data.data;
                        this.paotuiOrders[i].haveFreight =
                          currEt.freightPay || currEt.freight;
                        this.paotuiOrders[i].freight = currEt.freight;
                        this.paotuiOrders[i].freightPay = currEt.freightPay;
                        if (this.paotuiOrders[i].expressTakein) {
                          this.paotuiOrders[i].expressTakein.prepayId =
                            currEt.prepayId;
                        } else {
                          this.paotuiOrders[i].expressTakein = {
                            prepayId: currEt.prepayId
                          };
                        }
                        this.paotuiOrders[
                          i
                        ].expressCompanyId = currEt.expressCompany
                            ? currEt.expressCompany._id
                            : "";
                        this.paotuiOrders[
                          i
                        ].expressCompanyCode = currEt.expressCompany
                            ? currEt.expressCompany.code
                            : "";
                        this.paotuiOrders[
                          i
                        ].expressCompanyName = currEt.expressCompany
                            ? currEt.expressCompany.name
                            : "";
                        this.paotuiOrders[i].fromProvCode =
                          currEt.senderProvince.code;
                        this.paotuiOrders[i].toProvCode =
                          currEt.receiverProvince.code;
                        this.paotuiOrders = [...this.paotuiOrders];
                      } else {
                        weui.alert(etRes.data.message);
                      }
                    })
                    .catch(etErr => {
                      console.log(etErr);
                      weui.topTips("获取待取件信息出错", 2000);
                    });
                }

                if (
                  this.type == 2 &&
                  this.statusType == "ing" &&
                  this.paotuiOrders[i].type == 2 &&
                  this.paotuiOrders[i].status == 2 &&
                  this.userInfo.openid == this.paotuiOrders[i].acceptOpenid
                ) {
                  setTimeout(function () {
                    // 需要渲染文件上传组件
                    let currItem = that.paotuiOrders[i];
                    /* 图片自动上传 */
                    let uploadCount = 0,
                      uploadList = [];
                    let uploadCountDom = document.getElementById(
                      "uploadCount" + currItem._id
                    );
                    weui.uploader("#uploader" + currItem._id, {
                      url: "/api/upload/uploadFile",
                      auto: true,
                      type: "file",
                      fileVal: "fileVal",
                      compress: {
                        width: 1600,
                        height: 1600,
                        quality: 0.8
                      },
                      onBeforeQueued: function (files) {
                        if (
                          [
                            "image/jpg",
                            "image/jpeg",
                            "image/png",
                            "image/gif"
                          ].indexOf(this.type) < 0
                        ) {
                          weui.alert("请上传正确格式的图片");
                          return false;
                        }
                        if (this.size > 4 * 1024 * 1024) {
                          weui.alert("请上传不超过4M的图片");
                          return false;
                        }
                        if (files.length > 1) {
                          // 防止一下子选中过多文件
                          weui.alert("最多只能上传1张图片");
                          return false;
                        }
                        if (uploadCount + 1 > 1) {
                          weui.alert("最多只能上传1张图片");
                          return false;
                        }

                        ++uploadCount;
                        uploadCountDom.innerHTML = uploadCount;
                      },
                      onQueued: function () {
                        uploadList.push(this);
                      },
                      onBeforeSend: function (data, headers) {
                        headers["Authorization"] = "Bearer " + that.token;
                        // return false; // 阻止文件上传
                      },
                      onProgress: function (procent) { },
                      onSuccess: function (ret) {
                        console.log(ret.data);
                        currItem.goodsPic = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
                      },
                      onError: function (err) {
                        console.log(err);
                      }
                    });

                    // 缩略图预览
                    document
                      .querySelector("#uploaderFiles" + currItem._id)
                      .addEventListener("click", function (e) {
                        let target = e.target;

                        while (
                          !target.classList.contains("weui-uploader__file") &&
                          target
                        ) {
                          target = target.parentNode;
                        }
                        if (!target) return;

                        let url = target.getAttribute("style") || "";
                        let id = target.getAttribute("data-id");

                        if (url) {
                          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
                        }
                        let gallery = weui.gallery(url, {
                          className: "custom-name",
                          onDelete: function () {
                            weui.confirm("确定删除该图片？", function () {
                              --uploadCount;
                              uploadCountDom.innerHTML = uploadCount;
                              currItem.goodsPic = "";

                              for (
                                var i = 0, len = uploadList.length;
                                i < len;
                                ++i
                              ) {
                                var file = uploadList[i];
                                if (file.id == id) {
                                  file.stop();
                                  break;
                                }
                              }
                              target.remove();
                              gallery.hide();
                            });
                          }
                        });
                      });
                  }, 500);
                }
              }
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            this.haveData = false;
            loading.hide(function () { });
            weui.topTips("获取跑腿单数据出错", 2000);
          });
      }
    },
    gotoOtherStatus(status) {
      this.$router.push(
        "/robbingListCompleteOrCancel/" +
        this.type +
        "/" +
        status +
        "/" +
        this.encodeToken
      );
    },
    gotoPaotuiOrderDownload() {
      this.$router.push("/paotuiOrderForDownload/" + this.encodeToken);
    },
    singleOrder(_id) {
      this.singleOrderId = _id;
      if (!this.paotuiPicker) {
        this.paotuiPicker = this.$createPicker({
          title: "转单选择",
          data: [this.paotuis],
          onSelect: this.singleOrderHandle
        });
      }
      this.paotuiPicker.show();
    },
    singleOrderHandle(selectedVal, selectedIndex, selectedText) {
      this.acceptUser = this.paotuis[selectedIndex];
      // 执行转单逻辑处理
      let params = {
        paotuiId: this.singleOrderId,
        acceptUserId: this.acceptUser.value,
        acceptOpenid: this.acceptUser.openid,
        acceptUserName: this.acceptUser.realname,
        acceptUserPhone: this.acceptUser.phoneMain
      };
      axios
        .put("/api/paotuiOrder/rollout/single", params)
        .then(res => {
          if (res.data.success) {
            weui.toast("转单成功");
            for (let i = 0; i < this.paotuiOrders.length; i++) {
              if ((this.paotuiOrders[i]._id = this.singleOrderId)) {
                this.paotuiOrders.splice(i, 1);
                break;
              }
            }
            this.singleOrderId = "";
            this.acceptUser = {};
          } else {
            weui.alert("转单失败");
          }
        })
        .catch(err => {
          weui.alert("转单失败");
        });
    },
    batchOrder() {
      this.isBatchOrdering = true;
    },
    check(item) {
      if (item.check) {
        // 选择则加入到choosedPaotuiOrders 列表中
        this.choosedPaotuiOrders.push(item._id);
      } else if (!item.check) {
        for (let i = 0; i < this.choosedPaotuiOrders.length; i++) {
          if (this.choosedPaotuiOrders[i] == item._id) {
            this.choosedPaotuiOrders.splice(i, 1);
            break;
          }
        }
      }
    },
    cancelBatchOrder() {
      this.isBatchOrdering = false;
      this.acceptUser = {};
      for (let i = 0; i < this.paotuiOrders.length; i++) {
        this.paotuiOrders[i].check = false;
      }
      this.choosedPaotuiOrders = [];
    },
    chooseAcceptUser() {
      if (this.choosedPaotuiOrders.length == 0) {
        weui.alert("请选择您想转的跑腿单");
      } else {
        if (!this.paotuiPicker) {
          this.paotuiPicker = this.$createPicker({
            title: "转单选择",
            data: [this.paotuis],
            onSelect: this.batchOrderHandle
          });
        }
        this.paotuiPicker.show();
      }
    },
    batchOrderHandle(selectedVal, selectedIndex, selectedText) {
      this.acceptUser = this.paotuis[selectedIndex];
      // 执行批量转单逻辑处理
      let params = {
        paotuiIds: this.choosedPaotuiOrders,
        acceptUserId: this.acceptUser.value,
        acceptOpenid: this.acceptUser.openid,
        acceptUserName: this.acceptUser.realname,
        acceptUserPhone: this.acceptUser.phoneMain
      };
      axios
        .put("/api/paotuiOrder/rollout/batch", params)
        .then(res => {
          if (res.data.success) {
            weui.toast("转单成功");
            for (let i = 0; i < this.paotuiOrders.length; i++) {
              for (let j = 0; j < this.choosedPaotuiOrders.length; j++) {
                if ((this.paotuiOrders[i]._id = this.choosedPaotuiOrders[j])) {
                  this.paotuiOrders.splice(i, 1);
                }
              }
            }
            if (this.paotuiOrders.length == 0) {
              this.haveData = false;
            }
            this.choosedPaotuiOrders = [];
            this.acceptUser = {};
            this.isBatchOrdering = false;
          } else {
            weui.alert("转单失败");
          }
        })
        .catch(err => {
          weui.alert("转单失败");
        });
    },
    chooseExpress(item) {
      item.isEditing = true;
      let that = this;
      weui.picker(this.escPicker, {
        className: "custom-classname",
        container: "body",
        defaultValue: [""],
        onChange: function (result) { },
        onConfirm: function (result) {
          item.expressCompanyId = result[0].value;
          item.expressCompanyCode = result[0].code;
          item.expressCompanyName = result[0].label;

          if (item.expressCompanyName == "顺丰速运") {
            // 显示到付按钮
            item.showDaofu = true;
          } else {
            item.showDaofu = false;
            item.isDaofu = false;
          }

          if (item.freightWeight) {
            let params = {
              worksiteId: that.worksiteId,
              expressCode: item.expressCompanyCode,
              fromProvinceCode: item.fromProvCode,
              toProvinceCode: item.toProvCode,
              freightWeight: item.freightWeight
            };

            // 获取运费
            axios
              .get("/api/expressFreight/freight", { params })
              .then(res => {
                if (res.data.success) {
                  if (item.expressTakein && item.expressTakein.insureFreight) {
                    item.freight =
                      res.data.data + item.expressTakein.insureFreight;
                  } else {
                    item.freight = res.data.data;
                  }
                  that.paotuiOrders = [...that.paotuiOrders];
                } else {
                  item.freight = "";
                  that.paotuiOrders = [...that.paotuiOrders];
                  weui.alert(res.data.message);
                }
              })
              .catch(err => {
                item.freight = "";
                that.paotuiOrders = [...that.paotuiOrders];
                weui.alert("自动计算运费失败，请手动输入。");
              });
          }

          // 重制paotuiOrders
          that.paotuiOrders = [...that.paotuiOrders];
        },
        id: "expressSendCompanyPicker"
      });
    },
    daofu(item) {
      console.log(item);
    },
    cacheFreight(item) {
      this.tempFreightWeight = item.freightWeight;
    },
    clearFreight(item) {
      if (item.freightWeight != this.tempFreightWeight) {
        item.freight = "";
        this.paotuiOrders = [...this.paotuiOrders];
      }
    },
    getFreight(item) {
      if (item.freightWeight && item.expressCompanyId) {
        let params = {
          worksiteId: this.worksiteId,
          expressCode: item.expressCompanyCode,
          fromProvinceCode: item.fromProvCode,
          toProvinceCode: item.toProvCode,
          freightWeight: item.freightWeight
        };

        // 获取运费
        axios
          .get("/api/expressFreight/freight", { params })
          .then(res => {
            if (res.data.success) {
              // 如果存在保价，则需要加上保价费用
              if (item.expressTakein && item.expressTakein.insureFreight) {
                item.freight = res.data.data + item.expressTakein.insureFreight;
              } else {
                item.freight = res.data.data;
              }
              this.paotuiOrders = [...this.paotuiOrders];
            } else {
              item.freight = "";
              this.paotuiOrders = [...this.paotuiOrders];
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            item.freight = "";
            this.paotuiOrders = [...this.paotuiOrders];
            weui.alert("自动计算运费失败，请手动输入。");
          });
      }
    },
    addFreight(item) {
      let that = this;
      let url = "";
      if (item.isDaofu) {
        if (!item.expressCompanyId) {
          weui.alert("请选择快递公司");
          return;
        }
        url = "/api/expressTakein/freight/updateFreightDaofu";
      } else {
        if (!item.expressCompanyId) {
          weui.alert("请选择快递公司");
          return;
        } else if (!item.freightWeight) {
          weui.alert("请输入计费重量");
          return;
        } else if (!item.freight) {
          weui.alert("请输入运费");
          return;
        }
        url = "/api/expressTakein/freight/updateFreight";
      }

      let params = {
        id: item.bizId,
        expressCompanyId: item.expressCompanyId,
        freightWeight: item.freightWeight,
        goodsPic: item.goodsPic,
        isDaofu: item.isDaofu,
        freight: item.freight * 100
        // freight: 1
      };

      if (!item.goodsPic) {
        weui.confirm(
          "确定不用上传照片？",
          function () {
            axios
              .put(url, params)
              .then(res => {
                if (res.data.success) {
                  weui.toast("成功", 1500);
                } else {
                  console.log(res.data.message);
                  weui.alert("更新运费失败");
                }
              })
              .catch(err => {
                weui.alert("更新运费失败");
              });
          },
          function () { }
        );
      } else {
        axios
          .put(url, params)
          .then(res => {
            if (res.data.success) {
              weui.toast("成功", 1500);
            } else {
              console.log(res.data.message);
              weui.alert("更新运费失败");
            }
          })
          .catch(err => {
            weui.alert("更新运费失败");
          });
      }
    },
    cancel(item) {
      let that = this;
      weui.confirm(
        "确定取消该跑腿单？",
        function () {
          axios
            .put("/api/paotuiOrder/cancel/" + item.orderNo)
            .then(res => {
              if (res.data.success) {
                weui.toast("取消成功", 1000);
                // 删除进行中的这条记录
                for (let i = 0; i < that.paotuiOrders.length; i++) {
                  if (that.paotuiOrders[i]._id == item._id) {
                    that.paotuiOrders.splice(i, 1);
                    break;
                  }
                }
                if (that.paotuiOrders.length == 0) {
                  that.haveData = false;
                }
              } else {
                setTimeout(function () {
                  weui.alert("取消失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function () {
                weui.alert("取消失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    cancelAccept(item) {
      this.$router.push(
        "/cancelPaotuiAccept/" +
        item.orderNo +
        "/" +
        item.type +
        "/" +
        this.encodeToken
      );
    },
    songda(item) {
      weui.confirm(
        "确定该跑腿单已送达？",
        function () {
          axios
            .put("/api/paotuiOrder/receiverGet/" + item._id)
            .then(res => {
              if (res.data.success) {
                weui.toast("成功送达", 1000);
              } else {
                setTimeout(function () {
                  weui.alert("送达失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function () {
                weui.alert("送达失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    qianshou(item) {
      let that = this;
      weui.confirm(
        "确定已收到该快递件？",
        function () {
          axios
            .put("/api/paotuiOrder/receiverSignRollModule/" + item._id)
            .then(res => {
              if (res.data.success) {
                weui.toast("签收成功", 1000);
                // 跳转到跑腿完成页面，方便用户进行评价
                // that.$router.push("/robbingList/1/complete/" + that.encodeToken);
                // 跳转到评价页面
                that.$router.push(
                  "/comment/" +
                  item._id +
                  "/" +
                  item.acceptOpenid +
                  "/" +
                  encodeURIComponent(item.acceptUser) +
                  "/" +
                  encodeURIComponent(item.realArriveTime) +
                  "/" +
                  that.encodeToken
                );
              } else {
                setTimeout(function () {
                  weui.alert("签收失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function () {
                weui.alert("签收失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    qujian(item) {
      let that = this;
      weui.confirm(
        "确定快递已被跑腿取走？",
        function () {
          axios
            .put("/api/paotuiOrder/paotuiTakeaway/" + item._id)
            .then(res => {
              if (res.data.success) {
                weui.toast("已取件成功", 1000);
              } else {
                setTimeout(function () {
                  weui.alert("已取件失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function () {
                weui.alert("已取件失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    confirmQujian(item) {
      let that = this;
      let msg = "";
      if (item.goodsPic) {
        msg = "确定已取走待寄物品？";
      } else {
        msg = "确定已取走待寄物品并无需上传照片？";
      }
      weui.confirm(
        msg,
        function () {
          axios
            .put("/api/paotuiOrder/paotuiConfirmTakeaway/" + item._id, {
              goodsPic: item.goodsPic,
              isDaofu: item.expressTakein.isDaofu
            })
            .then(res => {
              if (res.data.success) {
                weui.toast("已取件成功", 1000);
              } else {
                setTimeout(function () {
                  weui.alert("已取件失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function () {
                weui.alert("已取件失败");
              }, 500);
            });
        },
        function () { }
      );
    },
    payFreight(item) {
      let that = this;
      // 获取支付签名
      let params = {
        package: item.expressTakein.prepayId
      };

      axios
        .get("/api/wx/paysign", { params })
        .then(response => {
          if (response.data.success) {
            let payConfig = response.data.data;
            payConfig.success = function (res) {
              // 直接改变当前item的状态为已付款
              item.freightPay = true;
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    },
    goPay(item) {
      let that = this;
      // 获取支付签名
      let params = {
        package: item.prepayId
      };

      axios
        .get("/api/wx/paysign", { params })
        .then(response => {
          if (response.data.success) {
            let payConfig = response.data.data;
            payConfig.success = function (res) {
              // 直接改变当前item的状态为待接单
              item.status = 0;
              item.statusStr = "待接单";
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    },
    comment(item) {
      this.$router.push(
        "/comment/" +
        item._id +
        "/" +
        item.acceptOpenid +
        "/" +
        encodeURIComponent(item.acceptUser) +
        "/" +
        encodeURIComponent(item.realArriveTime) +
        "/" +
        this.encodeToken
      );
    }
  }
};
</script>
<style scoped>
.robbing {
  font-size: 14px;
  margin: 0 auto;
}

.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}

.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}

.robbing-nav-item:last-child {
  border-right: none;
}

.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}

.robbing-title {
  height: 60px;
  line-height: 60px;
  background-color: rgb(36, 36, 36);
  display: flex;
  margin-top: 10px;
}

.robbing-title-left {
  width: 60px;
  height: 60px;
}

.robbing-title-left img {
  padding: 0px;
  width: 58px;
  height: 58px;
  object-fit: cover;
}

.robbing-title-center {
  flex: 1;
  background-color: #1aad19;
  color: white;
  text-align: left;
  padding-left: 20px;
  font-size: 16px;
  letter-spacing: 2px;
}

.robbing-title-center span {
  font-weight: bold;
}

.robbing-title-center .small-tip {
  font-size: 8px;
}

.robbing-title-center p:first-child {
  height: 32px;
  line-height: 32px;
}

.robbing-title-center p:last-child {
  height: 26px;
  line-height: 1em;
}

.robbing-title-right {
  width: 100px;
}

.robbing-go {
  width: 80px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  color: white;
  background-color: #1aad19;
  border-radius: 5px;
  font-size: 12px;
}

.robbing-progress {
  display: flex;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #eee;
  color: grey;
}

.robbing-progress-item {
  flex: 1;
}

.robbing-progress-item.clickable {
  color: orangered;
}

.robbing-progress-item.warning {
  color: gold;
}

.robbing-progress-item.done {
  color: #1aad19;
}

.progress-item-top {
  line-height: 1em;
  font-size: 32px;
  padding-top: 8px;
}

.progress-item-top i {
  font-size: 30px;
}

.progress-item-bottom {
  line-height: 1em;
}

.robbing .icon-daxiao-,
.order-add-to {
  font-size: 34px;
}

.robbing-order {
  margin-bottom: 10px;
}

.robbing-order-item {
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}

.order-item-top {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  border-top: #1aad19 3px solid;
}

.item-top-left {
  position: absolute;
  left: 10px;
  top: 0px;
  padding-top: 2px;
}

.item-top-left span {
  padding: 3px 5px;
  color: orange;
  border: 1px solid orange;
  border-radius: 3px;
  font-size: 12px;
}

.item-top-right {
  position: absolute;
  right: 10px;
  top: 0px;
  font-size: 14px;
  padding-top: 2px;
}

.robbing-order-add {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.order-add-start {
  white-space: normal;
  word-break: break-all;
  width: 120px;
  position: relative;
}

.order-add-start:before {
  content: "";
  position: absolute;
  right: 0px;
  top: -60px;
  border-left: 1px solid #eee;
  width: 1px;
}

.order-add-start i {
  color: rgb(37, 155, 36);
  font-size: 23px;
  position: relative;
  top: 3px;
}

.order-add-end {
  padding-right: 5px;
  width: 120px;
  position: relative;
}

.order-add-end:before {
  content: "";
  position: absolute;
  left: 0px;
  top: -60px;
  border-left: 1px solid #eee;
  width: 1px;
}

.order-add-end i {
  color: rgb(212, 54, 29);
  font-size: 23px;
  position: relative;
  top: 3px;
}

.order-add-to {
  flex: 1;
}

.robbing-order-msg {
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #eee;
}

.order-msg-item {
  flex: 1;
  text-align: center;
}

.robbing-order-remark {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  padding: 5px;
}

.order-remark-left {
  width: 60px;
  position: absolute;
  left: 0;
  right: 0;
}

.order-remark-center {
  text-align: left;
  border-left: 1px solid #eee;
  margin-left: 56px;
  padding-left: 10px;
}

.marginRight60 {
  margin-right: 60px;
}

.order-remark-right {
  width: 60px;
  position: absolute;
  right: 0px;
}

.robbing-order-get {
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: white;
  font-size: 16px;
}

.robbing-order-get.clickable {
  background-color: orangered;
}

.robbing-order-get.unclickable {
  background-color: grey;
}

.robbing-order-get.warning {
  background-color: gold;
}

.robbing-order-get.success {
  background-color: #1aad19;
}

.robbing-order-get.disable {
  background-color: grey;
}

.robbing-order-item {
  margin-top: 10px;
}

.robbing-order-push {
  display: block;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  font-size: 15px;
  color: white;
  border-radius: 100%;
  background-color: rgb(37, 155, 36);
}

.robbing-order-push span {
  display: inline-block;
  margin-top: 12px;
}

.empty-data {
  text-align: center;
  margin-top: 50px;
}

.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}

.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}

.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.go-pay {
  background-color: #1aad19;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
}

.zhuandan-single {
  background-color: lightseagreen;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 10px;
  margin-right: 10px;
}

.zhuandan-batch {
  background-color: orangered;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
}

.go-cancel {
  background-color: orangered;
  color: #ffffff;
  padding: 3px 5px;
  font-size: 12px;
  border-radius: 3px;
}

.block-img {
  width: 60px;
  height: 60px;
}

.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: yellow;
}

.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}

.paotui-order-no {
  flex: 1;
  text-align: left;
  margin-left: 10px;
  font-size: 18px;
}

.comment {
  flex: 1;
  text-align: left;
  margin-left: 10px;
}

.comment-good {
  background-color: green;
  padding: 2px 4px;
  color: #ffffff;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 5px;
  margin-right: 5px;
}

.comment-bad {
  background-color: red;
  padding: 2px 4px;
  color: #ffffff;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 5px;
  margin-right: 5px;
}

.warehousing-footer-item {
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 0px;
  line-height: 50px;
  color: #ffffff;
}

.warehousing-footer-item a {
  color: #ffffff;
}

.cancel-batch {
  background-color: orangered;
}

.batch-begin {
  background-color: lightseagreen;
}

.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/RobbingList.vue